import React from "react";

import { EMPTY_STRING, MEDIA_TYPES } from "../../../constants";
import { Icons } from "../../../assets/icons";
import IconButton from "../IconButton/IconButton";

const RecapUploadPreview = ({
  id,
  image,
  handleSelect,
  selectedFiles,
  handleOpenModal,
  showCheckBox = true,
  showDeleteIcon = false,
  onDelete,
}) => {
  const isChecked = selectedFiles?.includes(image);
  const isVideo = image?.file?.type?.startsWith(MEDIA_TYPES.VIDEO);
  const isUsedVideoElement = isVideo && !image?.thumbnailUrl;

  return image ? (
    <div className={`portfolio-item ${isChecked ? "selected" : EMPTY_STRING}`}>
      {isVideo && (
        <IconButton
          icon={<Icons.PlayIcon />}
          className="play-icon bg-transparent"
          width="37px"
          handleClick={() => handleOpenModal(id)}
        />
      )}
      {showCheckBox && (
        <label className="checkbox-wrapper">
          <input
            type="checkbox"
            onChange={() => handleSelect(image)}
            checked={isChecked}
          />
          <span className="checkbox-mark"></span>
        </label>
      )}

      {showDeleteIcon && (
        <div className="delete-wrapper">
          <IconButton
            icon={<Icons.DeleteRedIcon />}
            className="bg-transparent"
            width="14px"
            handleClick={onDelete}
          />
        </div>
      )}

      <div className="file-wrapper">
        {isUsedVideoElement ? (
          <video src={image.url} className="file-content" />
        ) : (
          <img
            alt=""
            src={image?.thumbnailUrl || image.url}
            className="file-content"
            style={{ cursor: "grab" }}
            onClick={() => handleOpenModal(id)}
          />
        )}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default RecapUploadPreview;
